/* Uses the theme's existing product forms and compare selection. */
(() => {
  let frame=0,unique=0;
  const observed=new WeakSet();
  function sync(){
    frame=0;
    let selected=[];
    try{selected=JSON.parse(localStorage.getItem('products-compare')||'[]');}catch(_error){}
    if(document.body.classList.contains('no-compare')!==(selected.length>=4))document.body.classList.toggle('no-compare',selected.length>=4);
    const used=new Set();
    document.querySelectorAll('[id="sort__list"]').forEach(list=>{list.id='bestek-sort-list-'+(++unique);});
    document.querySelectorAll('.js-compare-checkbox').forEach(input=>{
      const wrapper=input.closest('.compare-checkbox');
      if(used.has(input.id)||!input.id){input.id='bestek-compare-'+(++unique);const label=wrapper?.querySelector('label');if(label)label.htmlFor=input.id;}
      used.add(input.id);
      const checked=selected.includes(Number(input.dataset.productId));
      input.checked=checked;
      if(!checked&&input.hasAttribute('checked'))input.removeAttribute('checked');
      if(wrapper?.classList.contains('checked_label')!==checked)wrapper?.classList.toggle('checked_label',checked);
    });
    document.querySelectorAll('.collection-sortby-title:not([role])').forEach(control=>{
      control.setAttribute('role','button');control.tabIndex=0;
      control.addEventListener('keydown',event=>{if(event.key==='Enter'||event.key===' '){event.preventDefault();control.click();}});
    });
    const drawer=document.getElementById('productQuickview'),dock=drawer?.querySelector('.bestek-mobile-quick-actions');
    if(!dock)return;
    const native=drawer.querySelector('.pdp-action-wrapper button[type="submit"]'),proxy=dock.querySelector('button');
    dock.hidden=!native;
    if(native){
      const busy=native.getAttribute('aria-busy')==='true'||!!native.querySelector('[data-btn-loader]')||native.hasAttribute('loading');
      proxy.disabled=native.disabled||busy||native.classList.contains('disabled-button');
      const label=busy?'Adding…':native.textContent.trim()||'Add to cart';
      if(proxy.textContent!==label)proxy.textContent=label;
      if(proxy.getAttribute('aria-busy')!==String(busy))proxy.setAttribute('aria-busy',String(busy));
      if(!observed.has(native)){observed.add(native);new MutationObserver(schedule).observe(native,{attributes:true,childList:true,subtree:true});}
    }
    const url=drawer.querySelector('product-info[data-url]')?.dataset.url,link=dock.querySelector('a');
    if(url&&link.getAttribute('href')!==url)link.href=url;
  }
  function schedule(){if(!frame)frame=requestAnimationFrame(sync);}
  function scheduleRelevant(records){
    const selector='.js-compare-checkbox,[id="sort__list"],.collection-sortby-title,#productQuickview,.bestek-mobile-quick-actions';
    const relevant=records.some(record=>
      record.target.nodeType===1&&record.target.closest('#productQuickview')||
      Array.from(record.addedNodes).some(node=>node.nodeType===1&&(node.matches(selector)||node.querySelector(selector)))
    );
    if(relevant)schedule();
  }
  function start(){
    document.querySelector('[data-bestek-quick-add]')?.addEventListener('click',()=>{
      const native=document.querySelector('#productQuickview .pdp-action-wrapper button[type="submit"]');
      if(native&&!native.disabled&&!native.querySelector('[data-btn-loader]')&&!native.classList.contains('disabled-button'))native.click();
    });
    new MutationObserver(scheduleRelevant).observe(document.body,{childList:true,subtree:true});
    document.addEventListener('click',event=>{if(event.target.closest('.compare-checkbox,[data-remove-icon]'))schedule();});
    window.addEventListener('storage',schedule);sync();
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',start,{once:true});else start();
})();

/* Let keyboard users dismiss an open desktop navigation disclosure. */
document.addEventListener('keydown', event => {
  if(event.key!=='Escape')return;
  const disclosure=event.target.closest('.nav-menu-list > li > details[open]');
  if(!disclosure)return;
  disclosure.open=false;
  disclosure.classList.remove('open');
  disclosure.closest('.header-nav-blocks')?.classList.remove('megamenu-block');
  if(!document.querySelector('.header-nav-blocks details[open]'))document.body.classList.remove('megamenu-open','overflow-hidden');
  disclosure.querySelector(':scope > summary')?.focus();
  event.preventDefault();
});


/* Mobile navigation: expose the existing controls to keyboard and assistive input. */
(() => {
  const mounted = new WeakSet();
  function mount(root = document) {
    const menu = root.querySelector('#mobileMenu');
    const toggle = root.querySelector('[data-mobile-menu]');
    if (!menu || !toggle || mounted.has(menu)) return;
    mounted.add(menu);
    const mobile = window.matchMedia('(max-width:1023px)');
    const tabs = Array.from(menu.querySelectorAll('.menu-tab'));
    menu.setAttribute('role', 'navigation');
    menu.setAttribute('aria-label', 'Main navigation');
    menu.querySelector('.mobile-tabs-wrapper')?.setAttribute('role', 'tablist');
    tabs.forEach((tab, index) => {
      tab.id = menu.id + '-tab-' + index;
      tab.setAttribute('role', 'tab');
      const panel = menu.querySelector('.tabcontent.' + tab.dataset.tab);
      if (panel) {
        panel.id = menu.id + '-panel-' + index;
        panel.setAttribute('role', 'tabpanel');
        panel.setAttribute('aria-labelledby', tab.id);
        tab.setAttribute('aria-controls', panel.id);
      }
    });
    function update() {
      const open = mobile.matches && toggle.classList.contains('active');
      menu.inert = !open;
      menu.setAttribute('aria-hidden', String(!open));
      toggle.setAttribute('aria-expanded', String(open));
      tabs.forEach(tab => {
        const selected = tab.classList.contains('active');
        tab.setAttribute('aria-selected', String(selected));
        tab.tabIndex = open && selected ? 0 : -1;
      });
      menu.querySelectorAll('a[href], [data-submenu-trigger]').forEach(control => {
        control.tabIndex = open ? 0 : -1;
        if (control.matches('a[href]') && control.getAttribute('role') === 'menuitem') control.removeAttribute('role');
        if (control.hasAttribute('data-submenu-trigger')) {
          control.setAttribute('role', 'button');
          control.setAttribute('aria-expanded', String(control.classList.contains('active')));
          const name = control.closest('.nav-item-header')?.querySelector('a')?.textContent.trim() || 'submenu';
          control.setAttribute('aria-label', name + ' submenu');
        }
      });
    }
    menu.addEventListener('click', () => requestAnimationFrame(update));
    menu.addEventListener('keydown', event => {
      const tab = event.target.closest('.menu-tab');
      if (tab && ['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) {
        event.preventDefault();
        let index = tabs.indexOf(tab);
        if (event.key === 'Home') index = 0;
        else if (event.key === 'End') index = tabs.length - 1;
        else index = (index + (event.key === 'ArrowRight' ? 1 : -1) + tabs.length) % tabs.length;
        tabs[index].click(); update(); tabs[index].focus();
      } else if ((tab || event.target.matches('[data-submenu-trigger]')) && ['Enter', ' '].includes(event.key)) {
        event.preventDefault(); event.target.click(); update();
      }
    });
    function escape(event) {
      if (event.key === 'Escape' && mobile.matches && toggle.classList.contains('active')) {
        event.preventDefault(); toggle.click(); update(); toggle.focus();
      }
    }
    document.addEventListener('keydown', escape);
    const observer = new MutationObserver(update);
    observer.observe(toggle, {attributes: true, attributeFilter: ['class']});
    mobile.addEventListener('change', update);
    function unload(event) {
      if (!event.target.contains(menu)) return;
      observer.disconnect(); mobile.removeEventListener('change', update);
      document.removeEventListener('keydown', escape);
      document.removeEventListener('shopify:section:unload', unload);
    }
    document.addEventListener('shopify:section:unload', unload);
    update();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => mount(), {once: true});
  else mount();
  document.addEventListener('shopify:section:load', event => mount(event.target));
})();
